import { render, staticRenderFns } from "./MEMO.vue?vue&type=template&id=6fe99a5d&"
import script from "./MEMO.vue?vue&type=script&lang=js&"
export * from "./MEMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe99a5d')) {
      api.createRecord('6fe99a5d', component.options)
    } else {
      api.reload('6fe99a5d', component.options)
    }
    module.hot.accept("./MEMO.vue?vue&type=template&id=6fe99a5d&", function () {
      api.rerender('6fe99a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/MEMO.vue"
export default component.exports